import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Grid,
	Button as MuiButton,
	Typography,
} from '@material-ui/core';
import {
	Add as AddIcon,
	Edit as EditIcon,
	ExpandMore as ExpandMoreIcon,
} from '@material-ui/icons';
import { Button, MarkdownText, NoResults } from 'src/components';
import { type ChangeEvent, useEffect, useState } from 'react';
import { type IAnswer, type IQuestion } from 'src/models';
import { type RootState } from 'src/store';
import { useDispatch, useSelector } from 'react-redux';
import { userTypes } from 'src/helpers/constants';
import Answer from './Answer';
import QuestionDialog from '../QuestionDialog';
import answerActions from 'src/store/Answers/actions';
import useStyles from './Question-styles';

interface Props {
	question: IQuestion;
}

function Question({ question }: Props) {
	const classes = useStyles();
	const dispatch = useDispatch();
	const user = useSelector((state: RootState) => state.auth.data);
	const [expanded, setExpanded] = useState(false);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [answers, setAnswers] = useState<IAnswer[]>(question?.answers ?? []);
	const saveAnswers = (answers: IAnswer[]) => dispatch(answerActions.saveEdition(question.id || 0, answers));

	useEffect(() => {
		setAnswers(question.answers ?? []);
	}, [question.answers]);

	function handleAddAnswer() {
		setAnswers([
			...answers,
			{
				isCorrect: false,
				isNew: true,
				name: '',
			},
		]);
	}

	function handleSetValues(
		index: number,
		name: keyof IAnswer,
		value: string | boolean,
	) {
		const _answers = [...answers];

		if (_answers[index]) {
			_answers[index][name] = value;
			setAnswers(_answers);
		}
	}

	function isValid() {
		let anyIsCorrect = false;
		answers.forEach((answer: IAnswer) => {
			if (answer.isCorrect) {
				anyIsCorrect = answer.isCorrect;
			}
		});

		return answers.length > 0 && anyIsCorrect;
	}

	function handleSaveAnswers() {
		saveAnswers(answers);
	}

	return (
		<Grid className={classes.question} item xs={12}>
			<QuestionDialog
				handleOpen={() => {
					setDialogOpen(false);
				}}
				open={dialogOpen}
				question={question}
			/>

			<Accordion expanded={expanded}>
				<AccordionSummary
					IconButtonProps={{
						onClick: () => {
							setExpanded(!expanded);
						},
					}}
					expandIcon={<ExpandMoreIcon />}
				>
					<Grid container>
						<Grid item xs={11}>
							<MarkdownText value={question.name} />
						</Grid>

						<Grid className={classes.center} item xs={1}>
							{user.type === userTypes.ADMIN && (
								<MuiButton
									onClick={() => {
										setDialogOpen(true);
									}}
									startIcon={<EditIcon />}
								>
									{window.innerWidth <= 960 ? '' : 'Editar'}
								</MuiButton>
							)}
						</Grid>
					</Grid>
				</AccordionSummary>

				<AccordionDetails>
					<Grid container>
						<Grid item xs={12}>
							{answers?.length === 0 ? (
								<NoResults text={'No hay respuestas'} />
							) : (
								<Grid
									className={classes.answers}
									container
									spacing={2}
								>
									{answers?.map((
										answer: IAnswer,
										index: number,
									) => (
										<Answer
											answer={answer}
											handleIsCorrect={(event: ChangeEvent<HTMLInputElement>) => {
												handleSetValues(
													index,
													'isCorrect',
													event.target.checked,
												);
											}}
											handleSetName={(name: string) => {
												handleSetValues(
													index,
													'name',
													name,
												);
											}}
											isNew={answer.isNew}
											key={index}
										/>
									))}
								</Grid>
							)}

							{user.type === userTypes.ADMIN && (
								<div
									className={classes.addArea}
									onClick={handleAddAnswer}
								>
									<AddIcon />

									<Typography> Agregar respuesta </Typography>
								</div>
							)}
						</Grid>

						<Grid className={classes.actions} item xs={12}>
							{user.type === userTypes.ADMIN && (
								<Button
									actionType={'save'}
									backgroundColor={'white'}
									disabled={!isValid()}
									onClick={handleSaveAnswers}
								>
									Guardar respuestas
								</Button>
							)}
						</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>
		</Grid>
	);
}

export default Question;
